import { useEffect, useState } from 'react';
import { LocalStorage, KEYS } from '@/utils/LocalStorage';
import { useGetInitData } from '@viome/viome-base/src/usecase/Bootup/BootupQuery';
import { IKitType, kitDetails } from '@viome/viome-base/src/usecase/Bootup/BootupModel';

export interface BootupStatus {
  supplementRecsExists: boolean;
  recommendationIsLockedByStudyExists: boolean;
  recommendationExists: boolean;
  hasPersonalizedSupplementRecommendationsExists: boolean;
  kitType: IKitType;
  isEligibleForSupplements: boolean;
  rnrLastGeneratedDate: string;
  kitDetailsData: kitDetails;
  CDkitDetailsData: kitDetails;
  preRnRKitType: IKitType;
}

export const useBootup = () => {
  const {
    data: bootupData,
    isError: isErrorInBootup,
    isLoading: isLoadingBootup,
  } = useGetInitData();

  const [bootupState, setBootupState] = useState<BootupStatus | null>(null);

  const [isLoading, setLoading] = useState(true);
  const [hasError, setError] = useState(false);

  useEffect(() => {
    if (!isLoadingBootup && !isErrorInBootup && bootupData) {
      const { lockstatus, upsellMetaData, kitDetails, CDkitDetails, is_eligible_for_supplements } = bootupData;

      const supplementRecsExists = lockstatus?.hasSupplementRecs ?? false;
      const recommendationIsLockedByStudyExists =
        lockstatus?.recommendationIsLockedByStudy ?? false;
      const recommendationExists = lockstatus?.hasRecommendation ?? false;
      const hasPersonalizedSupplementRecommendationsExists =
        upsellMetaData?.hasPersonalizedSupplementRecommendations ?? false;
      const isEligibleForSupplements =  is_eligible_for_supplements;

      const kitType = kitDetails?.kitType;
      const preRnRKitType = kitDetails?.pre_rnr_kit_type;
      const rnrLastGeneratedDate = kitDetails?.lastRnRGeneratedDate;
      const kitDetailsData = kitDetails;
      const CDkitDetailsData = CDkitDetails;

      const newBootupState = {
        supplementRecsExists,
        recommendationIsLockedByStudyExists,
        recommendationExists,
        hasPersonalizedSupplementRecommendationsExists,
        kitType,
        isEligibleForSupplements,
        rnrLastGeneratedDate,
        kitDetailsData,
        CDkitDetailsData,
        preRnRKitType,
      };

      setBootupState(newBootupState);
      LocalStorage.setItem(KEYS.BOOTUP, JSON.stringify(newBootupState));
      setLoading(false);
      return;
    }

    if (isErrorInBootup) {
      setError(true);
      setLoading(false);
    }
  }, [bootupData, isErrorInBootup, isLoadingBootup]);

  return {
    bootupState,
    isError: isErrorInBootup || hasError,
    isLoading,
  };
};
